const brandName = process.env.NEXT_PUBLIC_BRAND_NAME || 'Laithwaites Wine';
const brand = process.env.NEXT_PUBLIC_COUNTRY_BRAND || '';

export function getSiteConfigByURL(id: string): string {
  switch (id) {
    case 'aus-vws':
      return 'redemption.virginwines.com.au';

    case 'aus-adc':
      return 'theaustralianwine.com.au';

    case 'aus-virgin':
      return 'virginwines.com.au';

    default:
      return 'laithwaites.com.au';
  }
}
export const complianceNotices = [
  {
    id: 'bender',
    title: 'Responsible Service of Alcohol',
    content:
      'You must be 18 years of age or over to order wine from this site. It is against the law to sell or supply alcohol to, or obtain alcohol on behalf of, a person under the age of 18.',
    image: 'drink-wise.png',
  },
  {
    id: 'carol',
    title: 'Self-exclusion',
    mailToBody:
      `mailto:customerservice@${getSiteConfigByURL(brand)}?subject=Voluntary%20Exclusion&body=I%20would%20like%20to%20voluntarily%20exclude%20myself%20from%20all%20${brandName}%20purchases%0A%0AAccount%20Number%3A%0AFirst%20Name%3A%0ALast%20Name%3A%0AEmail%20Address%3A%0AMobile%20Number%3A`,
    mailToLabel: `customerservice@${getSiteConfigByURL(brand)}`,
    content:
      `${brandName} is dedicated to the safety and wellbeing of our customers and aims to promote the responsible consumption of alcohol. By excluding yourself from ${brandName} services you will no longer be able to place orders on the ${brandName} website. To voluntarily exclude yourself please email the following details to:`,
  },
];